import { Button } from "@shapr3d/frontend-lib";
import classNames from "classnames";

import { useTracker } from "../../hooks/useTracker";

import style from "./DownloadSection.module.css"; // eslint-disable-line

const MacosButton: React.FC<{ downloadURL: string; preferred: boolean }> = ({
  downloadURL,
  preferred,
}) => {
  const tracker = useTracker();
  return (
    <div className={classNames(style.cell, style.mac, preferred && style.preferred)}>
      <Button
        id="download-shapr3d-macos-button"
        className={style.button}
        disabled={!downloadURL}
        variant="primary"
        onClick={() => {
          tracker.trackButtonClick({ elementId: "app-download-button" });
          window.location.assign(downloadURL);
        }}
      >
        Download from Shapr3D
      </Button>
      <div className={style.buttonDescription}>
        <span>Requires macOS Monterey (12.0) or later</span>
        <div>
          <a
            rel="noreferrer noopener"
            href="https://www.shapr3d.com/compatible-devices#mac"
            target="_blank"
          >
            See compatible Macs
          </a>
        </div>
      </div>
    </div>
  );
};

export default MacosButton;
